import endpoint from "../../config/endpoints";

export const leaveAllotmentJson = {
  showSaveNextBtn: true,
  apiBaseURL: endpoint.assignRateConfigurationToStakeholder,
  formPath: "/assign-rate-configuration-to-stakeholder-form",
  screenTitle: " Leave Structure Assigation",
  showTitle: true,
  showCancel: false,
  showSaveBtn: false,

  fieldMetaAdminArea: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 6,
      valueMD: 6,
      valueLG: 6,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Leave Structure",
      controlType: "autocomplete",
      placeHolder: "Select Leave Structure",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveStructureDetail",
      dataKey: "leaveStructure",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Leave Year",
      controlType: "autocomplete",
      placeHolder: "Select Leave Year",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveYearDetail",
      dataKey: "leaveYearMaster",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockStakeHolderTypeDetail",
      dataKey: "stockStakeHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },

    {
      label: "Region",
      controlType: "autocomplete",
      placeHolder: "Select Region",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "regionDetail",
      dataKey: "region",
      getListId: "region",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "State",
      controlType: "autocomplete",
      placeHolder: "Select State",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "stateDetail",
      dataKey: "state",
      getListFrom: "region",
      getListId: "state",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Zone",
      controlType: "multiSelect",
      placeHolder: "Select Zone",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "zoneDetail",
      dataKey: "zone",
      getListFrom: "state",
      getListId: "zone",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "District",
      controlType: "multiSelect",
      placeHolder: "Select District",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "districtDetail",
      dataKey: "district",
      getListFrom: "zone",
      getListId: "district",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Taluka",
      controlType: "multiSelect",
      placeHolder: "Select Taluka",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "talukaDetail",
      dataKey: "taluka",
      getListFrom: "district",
      getListId: "taluka",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area ",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "areaDetail",
      dataKey: "area",
      getListFrom: "taluka",
      isRootLevelKey: false,
      isMandatory: true,
      getListId: "area",
    },
  ],

  fieldMeta: [
    {
      label: "Leave Structure",
      controlType: "autocomplete",
      placeHolder: "Select Leave Structure",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveStructureDetail",
      dataKey: "leaveStructure",
      isRootLevelKey: true,
      isMandatory: true,
    },

    {
      label: "Leave Year",
      controlType: "autocomplete",
      placeHolder: "Select Leave Year",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveYearDetail",
      dataKey: "leaveYearMaster",
      isRootLevelKey: true,
      isMandatory: true,
    },

    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockStakeHolderTypeDetail",
      dataKey: "stockStakeHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area ",
      md: 5,
      lg: 5,
      sm: 5,
      xs: 12,
      masterName: "areaDetail",
      dataKey: "area",
      isRootLevelKey: false,
      isMandatory: true,
      getListId: "area",
    },
  ],

  fieldMetaForManager: [
    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockStakeHolderTypeDetail",
      dataKey: "stockStakeHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area ",
      md: 5,
      lg: 5,
      sm: 5,
      xs: 12,
      masterName: "areaDetail",
      dataKey: "area",
      isRootLevelKey: false,
      isMandatory: true,
      getListId: "area",
    },
  ],

  fieldMetaForAdminAreaGetById: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 6,
      valueMD: 6,
      valueLG: 6,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Leave Year",
      controlType: "autocomplete",
      placeHolder: "Select Leave Year",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveYearDetail",
      dataKey: "leaveYearMaster",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockStakeHolderTypeDetail",
      dataKey: "stockStakeHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },


    {
      label: "Region",
      controlType: "autocomplete",
      placeHolder: "Select Region",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "regionDetail",
      dataKey: "region",
      getListId: "region",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "State",
      controlType: "autocomplete",
      placeHolder: "Select State",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "stateDetail",
      dataKey: "state",
      getListFrom: "region",
      getListId: "state",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Zone",
      controlType: "multiSelect",
      placeHolder: "Select Zone",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "zoneDetail",
      dataKey: "zone",
      getListFrom: "state",
      getListId: "zone",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "District",
      controlType: "multiSelect",
      placeHolder: "Select District",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "districtDetail",
      dataKey: "district",
      getListFrom: "zone",
      getListId: "district",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Taluka",
      controlType: "multiSelect",
      placeHolder: "Select Taluka",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "talukaDetail",
      dataKey: "taluka",
      getListFrom: "district",
      getListId: "taluka",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area ",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,

      masterName: "areaDetail",
      dataKey: "area",
      getListFrom: "taluka",
      isRootLevelKey: false,
      isMandatory: true,
      getListId: "area",
    },
  ],
  fieldMetaForSearch: [
    {
      label: "Stock Holder Type",
      controlType: "multiSelect",
      placeHolder: "Select Stock Holder Type",
      md: 5,
      lg: 5,
      sm: 5,
      xs: 12,
      getListId: "stockStakeHolderType",
      masterName: "stakeHolderTypeDetail",
      dataKey: "stockStakeHolderType",
      isRootLevelKey: false,
      isMandatory: true,
    },
    {
      label: "Stock Holder Name",
      controlType: "multiSelect",
      placeHolder: "Select Stock Holder",
      md: 5,
      lg: 5,
      sm: 5,
      xs: 12,
      masterName: "stakeHolderName",
      dataKey: "stackholder",
      getListFrom: "stockStakeHolderType",
      isRootLevelKey: false,
      isMandatory: true,
    },
  ],
  fieldMetaForSalesTeam: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 6,
      valueMD: 6,
      valueLG: 6,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Leave Structure",
      controlType: "autocomplete",
      placeHolder: "Select  Leave Structure",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveStructureDetail",
      dataKey: "leaveStructure",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Leave Year",
      controlType: "autocomplete",
      placeHolder: "Select Leave Year",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveYearDetail",
      dataKey: "leaveYearMaster",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockStakeHolderTypeDetail",
      dataKey: "stockHolderType",
      getListId: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "salesExecutiveDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForSalesTeamGetById: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 6,
      valueMD: 6,
      valueLG: 6,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Leave Year",
      controlType: "autocomplete",
      placeHolder: "Select Leave Year",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveYearDetail",
      dataKey: "leaveYearMaster",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockStakeHolderTypeDetail",
      dataKey: "stockHolderType",
      getListId: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "salesExecutiveDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForUnderSalesTeam: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 6,
      valueMD: 6,
      valueLG: 6,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Leave Structure",
      controlType: "autocomplete",
      placeHolder: "Select Leave Structure",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveStructureDetail",
      dataKey: "leaveStructure",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Leave Year",
      controlType: "autocomplete",
      placeHolder: "Select Leave Year",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveYearDetail",
      dataKey: "leaveYearMaster",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockStakeHolderTypeDetail",
      dataKey: "stockHolderType",
      getListId: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "salesExecutiveDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Type",
      controlType: "multiSelect",
      placeHolder: "Select Stake Holder Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "typeDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamTypeId",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
  fieldMetaForUnderSalesTeamGetById: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 6,
      valueMD: 6,
      valueLG: 6,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
      ],
      isMandatory: true,
    },

    {
      label: "Leave Year",
      controlType: "autocomplete",
      placeHolder: "Select Leave Year",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveYearDetail",
      dataKey: "leaveYearMaster",
      isRootLevelKey: true,
      isMandatory: true,
    },

    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockStakeHolderTypeDetail",
      dataKey: "stockHolderType",
      getListId: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "salesExecutiveDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Type",
      controlType: "multiSelect",
      placeHolder: "Select Stake Holder Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "typeDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamTypeId",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
};
